<template>
  <div class="layout">
    <home @click-logo="handleLogoClicked">
      <template #logo>
        <span>DMS for MongoDB</span>
      </template>

      <template #aside>
        <layout-aside
          ref="aside"
        ></layout-aside>
      </template>
    </home>
  </div>
</template>

<script>
import Home from '@/views/layouts/Home';
import LayoutAside from './LayoutAside';
import { ss } from '@/utils/storage';

export default {
  name: 'Layout',

  components: {
    Home,
    LayoutAside
  },

  created(){
    ss.set('mojo', 'mogodb')
  },

  methods: {
    handleLogoClicked() {
      this.$router.push({ name: 'MongodbIndex', query: this.$route.query });
    }
  }
};
</script>
